import { render, staticRenderFns } from "./AreaMatrix.vue?vue&type=template&id=4a17b3e9"
import script from "./AreaMatrix.vue?vue&type=script&lang=js"
export * from "./AreaMatrix.vue?vue&type=script&lang=js"
import style0 from "./AreaMatrix.vue?vue&type=style&index=0&id=4a17b3e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports